import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { GenericLabelValue } from "src/app/shared/models/DTO/GenericLabelValue.dto";
import { ProductUseIntervalMetric, ProductUseMetric } from "src/app/shared/models/DTO/productUseMetric.dto";
import { FocusLinkProduct } from "src/app/shared/models/enums/FocusLInkProduct.enum";

@Component({
	selector: "app-product-use-dashboard",
	templateUrl: "./product-use-dashboard.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class ProductUseDashboardComponent implements OnInit {
	chartConfig = {
		type: "line",
		data: undefined,
	};

	metricDateView: number = 1;

	day: ProductUseIntervalMetric;
	week: ProductUseIntervalMetric;
	month: ProductUseIntervalMetric;

	productList: GenericLabelValue[] = [
		{
			value: undefined,
			label: "All",
		},
		{
			value: FocusLinkProduct.AtTable,
			label: "@table",
		},
		{
			value: FocusLinkProduct.CommandCenter,
			label: "CommandCenter",
		},
		{
			value: FocusLinkProduct.EGift,
			label: "EGift",
		},
		{
			value: FocusLinkProduct.MobilePay,
			label: "MobilePay",
		},
		{
			value: FocusLinkProduct.OnlineOrder,
			label: "Online Order",
		},
		{
			value: FocusLinkProduct.POS,
			label: "POS",
		},
		{
			value: FocusLinkProduct.Subscriptions,
			label: "Subscriptions",
		},
	];

	productSelected: string = FocusLinkProduct.OnlineOrder;
	constructor(public app: AppService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		this.venueService.productStatisticMetric.subscribe((metricData) => {
			if (metricData.data && metricData.data.length > 0) {
				let data = { ...metricData };
				console.log(`metric data complete`);
				this.buildChart(data.data);

				this.day = data.day.find((i) => i.product === "onlineorder");
				this.week = data.week.find((i) => i.product === "onlineorder");
				this.month = data.month.find((i) => i.product === "onlineorder");
			} else {
				this.chartConfig.data = undefined;
			}
		});
	}

	buildChart(metricData: ProductUseIntervalMetric[]) {
		this.chartConfig.data = {
			labels: metricData.map((i) => this.app.moment(i.date, "YYYY-MM-DD").format("l")),
			datasets: [
				{
					label: "Visits",
					data: metricData.map((i) => i.visits),
					fill: false,
					borderColor: "#006394",
				},
				{
					label: "Completed orders",
					data: metricData.map((i) => i.completes),
					fill: false,
					borderColor: "#58b81d",
				},
				{
					label: "Abandoned cart",
					data: metricData.map((i) => i.abandons),
					fill: false,
					borderColor: "#ed4242",
				},
			],
		};
	}

	changeMetricDate() {
		switch (this.metricDateView) {
			case 1:
				this.metricDateView = 2;
				break;
			case 2:
				if (this.month.visits) {
					this.metricDateView = 3;
				} else {
					this.metricDateView = 1;
				}

				break;
			case 3:
				this.metricDateView = 1;
				break;
		}
	}

	applyProductFilter(data?: ProductUseMetric) {
		let metricData;
		if (data) {
			metricData = { ...data };
		} else {
			metricData = { ...this.venueService.productStatisticMetric.value };
		}

		if (this.productSelected) {
			console.log(metricData);
			this.day = metricData.day.find((i) => i.product === this.productSelected) || new ProductUseIntervalMetric({});

			this.week = metricData.week.find((i) => i.product === this.productSelected) || new ProductUseIntervalMetric();
			this.month = metricData.month?.find((i) => i.product === this.productSelected) || new ProductUseIntervalMetric();
			this.buildChart(metricData.data.filter((i) => i.product === this.productSelected));
		} else {
			this.day = new ProductUseIntervalMetric();
			this.week = new ProductUseIntervalMetric();
			this.month = new ProductUseIntervalMetric();

			metricData.day.forEach((m) => {
				this.day.abandons += m.abandons;
				this.day.completes += m.completes;
				this.day.date = m.date;
				this.day.desktop += m.desktop;
				this.day.mobile += m.mobile;
				this.day.product = "All";
				this.day.visits += m.visits;
				m.cities.forEach((c) => {
					this.day.cities.push(c);
				});
			});
			metricData.week.forEach((m) => {
				this.week.abandons += m.abandons;
				this.week.completes += m.completes;
				this.week.date = m.date;
				this.week.desktop += m.desktop;
				this.week.mobile += m.mobile;
				this.week.product = "All";
				this.week.visits += m.visits;
				m.cities.forEach((c) => {
					this.week.cities.push(c);
				});
			});
			metricData.month?.forEach((m) => {
				this.month.abandons += m.abandons;
				this.month.completes += m.completes;
				this.month.date = m.date;
				this.month.desktop += m.desktop;
				this.month.mobile += m.mobile;
				this.month.product = "All";
				this.month.visits += m.visits;
				m.cities.forEach((c) => {
					this.month.cities.push(c);
				});
			});

			this.buildChart(metricData.data);
		}
	}
}
